export const SET_ACCOUNT_TAB = "SET_ACCOUNT_TAB";
export const SET_OVERVIEW_TAB = "SET_OVERVIEW_TAB";

export const setAccountTab = index => ({
  type: SET_ACCOUNT_TAB,
  index: index
});

export const setOverviewTab = index => ({
  type: SET_OVERVIEW_TAB,
  index: index
});



// WEBPACK FOOTER //
// ./src/actions/route.js